import {HoistModel, managed, TaskObserver, XH} from '@xh/hoist/core';
import {action, observable} from '@xh/hoist/mobx';
import {Workflow} from '../../data/DataTypes';
import {FormModel} from '@xh/hoist/cmp/form';
import {required} from '@xh/hoist/data';
import {asServerException} from '../../../core/ServiceUtils';
import {sortBy} from 'lodash';
import {parseExpression} from 'cron-parser';
import cronstrue from 'cronstrue';

export class WorkflowEditorModel extends HoistModel {
    apiTask = TaskObserver.trackLast();
    private origWorkflow: Workflow;
    @observable accessor isOpen: boolean;
    @observable accessor isEditMode: boolean;
    @observable accessor description: string;
    @managed formModel = this.createFormModel();

    constructor() {
        super();

        this.addReaction({
            track: () => this.formModel.values.schedule,
            run: cron => this.updateDescription(cron)
        });
    }

    @action open(workflow: Workflow) {
        this.formModel.init({});
        this.isOpen = true;
        this.isEditMode = workflow != null;
        this.origWorkflow = workflow;
        this.description = null;
        this.formModel.init(workflow ?? {});
    }

    @action close() {
        this.isOpen = false;
    }

    async save() {
        const data = this.formModel.values,
            workflow: Workflow = {
                id: data.id ?? 0,
                name: data.name,
                command: data.command,
                commandParams: data.commandParams.map(p => {
                    return {key: p.key, value: p.value};
                }),
                schedule: data.schedule,
                isEnabled: !!data.isEnabled,
                updated: data.updated,
                updatedBy: data.updatedBy,
                timestamp: this.origWorkflow?.timestamp
            };

        try {
            await XH.workflowService.saveWorkflowAsync(workflow);
        } catch (e) {
            XH.handleException(asServerException(e), {title: 'Error saving workflow'});
        }
        this.close();
    }

    get commands(): string[] {
        return sortBy(XH.workflowService.commands);
    }

    @action
    private updateDescription(cron: string) {
        try {
            this.description = cronstrue.toString(cron);
        } catch {}
    }

    private createFormModel(): FormModel {
        return new FormModel({
            fields: [
                {name: 'id'},
                {name: 'name', rules: [required]},
                {name: 'command', rules: [required]},
                {
                    name: 'schedule',
                    rules: [
                        required,
                        {
                            check: ({value}) => {
                                try {
                                    parseExpression(value);
                                    return null;
                                } catch (e) {
                                    return e.message;
                                }
                            }
                        }
                    ]
                },
                {name: 'isEnabled'},
                {
                    name: 'commandParams',
                    subforms: {
                        fields: [
                            {name: 'key', rules: [required]},
                            {name: 'value', rules: [required]}
                        ]
                    }
                },
                {name: 'timestamp'}
            ]
        });
    }
}
